module.exports = __webpack_public_path__ + "3296cdcd1ce4c030b6618390d6dabe26.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/left_hand/chili.png
// module id = 2993
// module chunks = 0